import { KaivaIcon } from './KaivaIcon';

type KaivaAvatarProps = {
  size?: number;
  pulse?: boolean;
  className?: string;
};

export function KaivaAvatar({ size = 22, pulse = false, className }: KaivaAvatarProps) {
  return (
    <span
      className={`relative inline-grid flex-shrink-0 place-items-center ${className ?? ''}`.trim()}
      style={{ width: size, height: size }}
    >
      {pulse && (
        <span
          aria-hidden="true"
          className="kv-avatar__pulse pointer-events-none absolute"
          style={{ inset: -3, borderRadius: 10 }}
        />
      )}
      <KaivaIcon size={size} />
    </span>
  );
}
